import {Button, MenuProps, Tooltip} from "antd";
import {ColProps, colTypeOptions, FetchProps, FilterProps, filterTypeOptions} from "../../components/table/tableTypes";
import {exportToCsv} from "../../utils/exportToCsv";
import {
    dateDaysAgo,
    formatDate, shortFormatDate,
    shortFormatDateNoTime
} from "../../utils/friendlyDate";
import Table from "../../components/table/Table";
import {getAbandonedCheckoutsLog} from "../../api/getAbandonedCheckoutsLog";

import {IgnoredCheckoutTooltipContent} from "./IgnoredCheckoutTooltipContent";
import {RecoverableCheckoutTooltipContent} from "./RecoverableCheckoutTooltipContent";
import {useState} from "react";
import Panel from "../../components/panel/Panel";
import CheckoutPanel from "../../components/checkoutPanel/CheckoutPanel";

const CheckoutsTable = () => {
    const [checkoutId, setCheckoutId] = useState<number | undefined>(undefined);

    const statusOptions: MenuProps['items'] = [
        {key: 'recoverable', label: 'Recoverable'},
        {key: 'recovered', label: 'Recovered'},
        {key: 'lost', label: 'Lost'},
        {key: 'completed', label: 'Completed'},
    ]

    const fetch = async ({ filters, sortingBy, sortingDirection, limit, offset, selectedDomain, isCsvCall }: FetchProps) => {
        const response = await getAbandonedCheckoutsLog(selectedDomain, filters);
        if(isCsvCall) {
            exportToCsv(response.data.report, `Vuelve Abandoned Checkouts Log - ${selectedDomain} - ${formatDate(new Date())}`);
        } else {
            return selectedDomain ? response : [];
        }
    }

    const onCheckoutClick = (row: any) => {
        setCheckoutId(row.id);
    }

    const cols: ColProps[] = [
        { key: 'day', name: 'Date', type: colTypeOptions.date, maxWidth: 120, paddingLeft: 0, render: (value: Date, row: any) => {
            row.id === 4726 && console.log("value: ", value);
            return <Tooltip title={(shortFormatDate(new Date(value)).toString())}>{shortFormatDateNoTime(new Date(value))}</Tooltip>;
        } },
        { key: 'id', name: 'ID', type: colTypeOptions.text, maxWidth: 100 },
        { key: 'status', name: 'Status', type: colTypeOptions.text, width: 130, render: (value: string, row: any, reFetch) => (
            <Tooltip title={value === "recoverable" && row.should_ignore ?
                <IgnoredCheckoutTooltipContent checkoutId={row.id} reFetch={reFetch} /> :
                value === "recoverable" && row.future_messages > 0 ?
                <RecoverableCheckoutTooltipContent checkoutId={row.id} reFetch={reFetch} /> : ''}>
                <div className={`status ${value} ${value === "recoverable" && row.should_ignore ? 'ignored' : ''}`}>{value === "recoverable" && row.should_ignore ? 'Skipped' : value}</div>
            </Tooltip>
        )},
        { key: 'client_id', name: 'Client', type: colTypeOptions.text, maxWidth: 150, render: (value: string, row: any) => <Tooltip title={`ID: ${value}`}>{<span className="capitalize">{row.full_name}</span>}</Tooltip> },
        { key: 'price_usd', name: 'Price', type: colTypeOptions.usd, maxWidth: 90 },
        { key: 'messages_sent', name: 'Messages Sent', type: colTypeOptions.number, width: 100, render: (value: string, row: any) =>
                <Tooltip title={row.group_messages_sent && row.group_messages_sent !== row.messages_sent ? `${row.group_messages_sent} ${row.group_messages_sent > 1 ? ' messages ' : ' message '} were sent for a previous checkout by the same customer. This led to this new checkout.` : ''}>
                    {row.messages_sent}{row.group_messages_sent && row.group_messages_sent !== row.messages_sent ? ` (${row.group_messages_sent - row.messages_sent} prev.)` : ''}
                </Tooltip>
        },
        { key: 'future_messages', name: 'Messages Remain', type: colTypeOptions.number, width: 100 },
        // { key: 'total_orders', name: 'Converted', type: colTypeOptions.number, width: 100, render: (value: number) => <div className={`converted ${value > 0 ? 'checked' : ''}`}>{value > 0 ? <CheckCircleFilled /> : <CloseCircleFilled />}</div> },

    ];

    const filters: FilterProps[] = [
        { filterKey: 'days', name: 'date range', type: filterTypeOptions.date, min: dateDaysAgo(120), max: new Date(), from: dateDaysAgo(7), to: new Date() },
        { filterKey: 'status', name: 'status', type: filterTypeOptions.textToKey, options: statusOptions, allLabel: 'All Statuses', selected: 0 },
        { filterKey: 'checkoutId', name: 'checkout ID', type: filterTypeOptions.text },
        { filterKey: 'clientId', name: 'client ID', type: filterTypeOptions.text },
        { filterKey: 'phone', name: 'phone', type: filterTypeOptions.text }
    ];

    return (
        <div className="reports-container">
            <Table onRowClick={onCheckoutClick} title="Checkouts Log" fetch={fetch} cols={cols} filters={filters} showSearch={false} doneLoadingDependencies={true} />
            <CheckoutPanel checkoutId={checkoutId} onClose={() => setCheckoutId(undefined)} />
        </div>
    );
}

export default CheckoutsTable;